//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/meterType';
export default {
  data: function data() {
    return {
      rules: {
        meterName: [{
          required: true,
          message: '请输入仪表类型名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'change'
        }],
        meterUnint: [{
          required: true,
          message: '请选择计量单位',
          trigger: 'change'
        }]
      },
      meterId: 0,
      childData: {},
      //计量单位下拉框
      meterUnintOptions: [{
        value: 5,
        label: '度'
      }, {
        value: 6,
        label: '吨'
      }, {
        value: 7,
        label: 'm³'
      }]
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          meterId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          var temp = response.data.data;
          console.log('temp', temp);

          if (temp.meterUnint === "5") {
            temp.meterUnint = 5;
          } else if (temp.meterUnint === "6") {
            temp.meterUnint = 6;
          } else {
            temp.meterUnint = 7;
          }

          _this.childData = temp;
          console.log('temp123', _this.childData);
        });
      } else {
        this.meterId = '';
        this.childData = {
          meterName: '',
          meterRemark: '',
          meterUnint: '',
          meterIsEnable: 1
        };
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};